import "./App.css";
import RouterComponent from "./pages/Routes";

function App() {
  return (
    <>
      <RouterComponent />
    </>
  );
}

export default App;
